import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink } from 'react-router-dom';
import config from '../../config';
import { getLogout, username, role } from '../Actions/AuthAction';


const Page404 = (props) => {




    return (
        <>
            <div className="d-flex justify-content-center align-items-center errorpage">
                <div className="col-md-6 text-center">
                    <h1>Oops!</h1>
                    <h6>404- PAGE NOT FOUND</h6>
                    <p>The page you are looking for might has been removed had its name changes or is temprorarily unavailable.</p>
                    <Link to="/" class="btn btn-primary-custom">Go to Home Page</Link>
                </div>
            </div>
        </>
    )

}
export default Page404
